export const TASK_AREA_STATUSES = {
  PENDING: "Pending",
};

export const SCHEDULE_STATUSES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PROPOSED: "Proposed",
};
